export enum SituacaoRescisoesEnum {
	ABERTA = -1,
	ENVIADA = 0,
    EFETUADA = 1,
    CANCELADA = 2,
    EXCLUIDA = 3,
    RECUSADA = 4
}
